import ProjectForm from '../components/forms/ProjectForm'
import StatusBadge from '../components/StatusBadge'
import React, { useState, useEffect } from 'react'
import TaskMetadata from '../components/TaskMetadata'

export default function ProjectPage({
  page,
  selectedProject,
  projects,

  projectName,
  setProjectName,
  projectFocusAreaId,
  setProjectFocusAreaId,
  projectStatusId,
  setProjectStatusId,
  projectNotes,
  setProjectNotes,

  focusAreas,
  statusLevels,

  editingProjectId,
  saveProject,
  clearProjectForm,

  projectSearch,
  setProjectSearch,
  projectFilterFocusArea,
  setProjectFilterFocusArea,
  projectFilterStatus,
  setProjectFilterStatus,

  getTasksForProject,
  getRecurringForProject,

  openProject,
  editProject,
  deleteProject,

  clearProjectDetailForms,
  setPage,

  projectTaskName,
  setProjectTaskName,
  projectTaskNotes,
  setProjectTaskNotes,
  saveProjectTask,
  completeTask,

  projectRecurringName,
  setProjectRecurringName,
  projectRecurringNotes,
  setProjectRecurringNotes,
  projectRecurringFrequency,
  setProjectRecurringFrequency,
  saveProjectRecurring,

  startEditRecurring,

  showArchived,
    setShowArchived,

archiveProject,
attemptDeleteProject,

  recurrenceType,
  recurringDaysOfWeek,
  setRecurringDaysOfWeek,

  startEdit,

  editIcon,
  deleteIcon
  
}) {

  const filteredProjects = projects.filter(project =>
    showArchived ||
    project.status_levels?.name !== 'Archive'
)

const [animatingTaskId, setAnimatingTaskId] = React.useState(null)

async function animateCompleteTask(task) {

  setAnimatingTaskId(task.id)

  await new Promise(resolve => setTimeout(resolve, 350))

  await completeTask(task)

  setAnimatingTaskId(null)
}



return(
<>

{/* PROJECTS PAGE */}
{page === 'projects' && (
<>
  <div className="header">
    <div>
      <h2 className="season-list-title">Projects</h2>
      <div className="tagline">
        Your bigger-picture workspaces
      </div>
    </div>
  </div>

  <hr />

  {/* ADD PROJECT CARD */}
  <ProjectForm
  projectName={projectName}
  setProjectName={setProjectName}
  projectFocusAreaId={projectFocusAreaId}
  setProjectFocusAreaId={setProjectFocusAreaId}
  projectStatusId={projectStatusId}
  setProjectStatusId={setProjectStatusId}
  projectNotes={projectNotes}
  setProjectNotes={setProjectNotes}
  focusAreas={focusAreas}
  statusLevels={statusLevels}
  editingProjectId={editingProjectId}
  saveProject={saveProject}
  clearProjectForm={clearProjectForm}
/>

  <hr />

  <div style={{ marginBottom: '20px', display: 'flex', gap: '10px', flexWrap: 'wrap' }}>

  <input
    type="text"
    placeholder="Search projects..."
    value={projectSearch}
    onChange={(e) => setProjectSearch(e.target.value)}
    style={{
      padding: '8px',
      minWidth: '220px',
      borderRadius: '8px',
      border: '1px solid #ccc'
    }}
  />

  <select
    value={projectFilterFocusArea}
    onChange={(e) => setProjectFilterFocusArea(e.target.value)}
    style={{
      padding: '8px',
      borderRadius: '8px'
    }}
  >
    <option value="all">All Focus Areas</option>

    {focusAreas
      .slice()
      .sort((a, b) => a.name.localeCompare(b.name))
      .map(area => (
        <option key={area.id} value={area.id}>
          {area.name}
        </option>
      ))}

  </select>

      <select
        value={projectFilterStatus}
        onChange={(e) => setProjectFilterStatus(e.target.value)}
        style={{
          padding: '8px',
          borderRadius: '8px'
        }}
      >
        <option value="">All Statuses</option>

        {statusLevels
          .slice()
          .sort((a, b) => a.sort_order - b.sort_order)
          .map(status => (
            <option
              key={status.id}
              value={status.id}
            >
              {status.name}
            </option>
          ))}
      </select>

        <label>
            <input
                type="checkbox"
                checked={showArchived}
                onChange={() =>
                    setShowArchived(!showArchived)
                }
            />

            Show Archived
        </label>

  </div>

  <hr />

  <h3>Your Projects</h3>

  {projects.length === 0 ? (
    <div className="empty-state">
      📁 No projects yet.<br />
      Create one above to get started.
    </div>
  ) : (
    projects
      .filter(project => {

        const matchesSearch =
          !projectSearch ||
          project.name
            .toLowerCase()
            .includes(projectSearch.toLowerCase())

        const matchesFocus =
          projectFilterFocusArea === 'all' ||
          !projectFilterFocusArea ||
          project.focus_area_id === Number(projectFilterFocusArea)

        const matchesStatus =
          !projectFilterStatus ||
          project.status_id === Number(projectFilterStatus)

        const visibleProject =
            showArchived ||
            project.status_levels?.name !== 'Archive'

        return (
            visibleProject &&
            matchesSearch &&
            matchesFocus &&
            matchesStatus
        )

      })
      .map(project => {

      const openCount = getTasksForProject(project.id)
        .filter(t => !t.is_completed).length

      const doneCount = getTasksForProject(project.id)
        .filter(t => t.is_completed).length

      const recurringCount =
        getRecurringForProject(project.id).length

      const canDelete =
        openCount === 0 &&
        doneCount === 0 &&
        recurringCount === 0


      return (
        <div
          key={project.id}
          onClick={() => openProject(project)}
          className="season-list-card"
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              gap: '16px'
            }}
          >
            {/* LEFT SIDE */}
            <div style={{ flex: 1 }}>
              <div className="season-list-name">

                📁 {project.name}
              </div>

              <div className="season-list-meta">
                📋 Open: {openCount}
                {' • '}
                🔁 Recurring: {recurringCount}
                {' • '}
                ✅ Done: {doneCount}
                

                {project.focus_area?.name && (
                  <div className="tagline">
                    🎯 {project.focus_area.name}
                  </div>
                )}

                <StatusBadge status={project.status_levels?.name} />
              </div>

              {project.notes && (
                <div
                  style={{
                    marginTop: '6px',
                    fontSize: '14px',
                    color: '#5b6475',
                    maxWidth: '650px',
                    lineHeight: '1.4'
                  }}
                >
                  {project.notes}
                </div>
              )}
            </div>

            {/* RIGHT SIDE BUTTONS */}
            <div className="task-actions">

            {/* EDIT */}
            <button
                className={`circle-btn btn-edit ${
                editingProjectId === project.id ? 'active' : ''
                }`}
                onClick={(e) => {
                e.stopPropagation()
                editProject(project)
                }}
            >
                <img src={editIcon} className="icon" alt="Edit" />
            </button>

            {/* ARCHIVE */}
            <button
                className="circle-btn btn-archive"
                onClick={(e) => {
                e.stopPropagation()
                archiveProject(project.id)
                }}
                title="Archive Project"
            >
                📦
            </button>

            {/* DELETE (only if project is empty) */}
            {canDelete && (
                <button
                className="circle-btn btn-delete"
                onClick={(e) => {
                    e.stopPropagation()
                    attemptDeleteProject(project)
                }}
                title="Delete Project"
                >
                <img src={deleteIcon} className="icon" alt="Delete" />
                </button>
            )}

            </div>
            </div>
          </div>
      )
    })
  )}
</>
)}

{/* PROJECT DETAIL PAGE */}
{page === 'projectDetail' && selectedProject && (
  <div className="page-card">

    {/* HERO */}
    <div className="season-hero">
      <h2 style={{ marginTop: 0 }}>
        📁 {selectedProject.name}
      </h2>

      {selectedProject.notes && (
        <div
          style={{
            fontSize: '14px',
            color: '#666',
            marginTop: '6px'
          }}
        >
          {selectedProject.notes}
        </div>
      )}

      <div className="stats" style={{ marginBottom: '16px' }}>
        <div>📋 Open: {getTasksForProject(selectedProject.id).filter(t => !t.is_completed).length}</div>
        <div>🔁 Recurring: {getRecurringForProject(selectedProject.id).length}</div>
        <div>✅ Done: {getTasksForProject(selectedProject.id).filter(t => t.is_completed).length}</div>
      </div>

      <div style={{ marginTop: '14px' }}>
        <button
          onClick={() => {
            setPage('projects')
            clearProjectDetailForms()
          }}
        >
          ← Back to Projects
        </button>
      </div>
    </div>

    {/* ADD TASKS / RECURRING */}
    <div style={{ marginBottom: '18px' }}>
      <h3
        style={{
          margin: 0,
          color: '#0047AB'
        }}
      >
        Manage Work for {selectedProject.name}
      </h3>

      <div className="tagline">
        Add one-time tasks or recurring support systems
      </div>
    </div>

    <div
      style={{
        display: 'flex',
        gap: '10px',
        flexWrap: 'wrap',
        marginBottom: '12px'
      }}
    >
      {/* TASK INPUT */}
       
        <input
        placeholder="Task name..."
        value={projectTaskName}
        onChange={(e) =>
          setProjectTaskName(e.target.value)
        }
      />

      <input
        placeholder="Task notes..."
        value={projectTaskNotes}
        onChange={(e) =>
          setProjectTaskNotes(e.target.value)
        }
      />

      <button onClick={saveProjectTask}>
        Add Task
      </button>

      {/* RECURRING INPUT */}
      <input
        placeholder="Recurring task..."
        value={projectRecurringName}
        onChange={(e) =>
          setProjectRecurringName(
            e.target.value
          )
        }
      />

      <input
        placeholder="Recurring notes..."
        value={projectRecurringNotes}
        onChange={(e) =>
          setProjectRecurringNotes(
            e.target.value
          )
        }
      />

      <select
        value={projectRecurringFrequency}
        onChange={(e) =>
          setProjectRecurringFrequency(
            e.target.value
          )
        }
      >
        <option value="once">Once</option>
        <option value="daily">Daily</option>
        <option value="weekly">Weekly</option>
        <option value="monthly">Monthly</option>
        <option value="yearly">Yearly</option>
      </select>

        {Number(recurrenceType) === 2 && (
      <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
        {['Sun','Mon','Tue','Wed','Thu','Fri','Sat'].map((label, index) => (
          <label key={index} style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
            <input
              type="checkbox"
              checked={recurringDaysOfWeek.includes(index)}
              onChange={(e) => {
                if (e.target.checked) {
                  setRecurringDaysOfWeek([...recurringDaysOfWeek, index])
                } else {
                  setRecurringDaysOfWeek(recurringDaysOfWeek.filter(d => d !== index))
                }
              }}
            />
            {label}
          </label>
        ))}
      </div>
    )}

      <button onClick={saveProjectRecurring}>
        Add Recurring
      </button>
    </div>

    {/* OPEN TASKS */}
    <h3 className="section-title">
      Open Tasks ({getTasksForProject(selectedProject.id).filter(t => !t.is_completed).length})
    </h3>

    {getTasksForProject(selectedProject.id)
      .filter(t => !t.is_completed)
      .length === 0 ? (
      <div className="empty-state">
       🌱 No open tasks yet. Add one above to get momentum.
      </div>
    ) : (
      getTasksForProject(selectedProject.id)
        .filter(t => !t.is_completed)
        .map(task => (
            <div
                key={task.id}
                className={`season-task-card ${
                    animatingTaskId === task.id ? 'task-completing' : ''
                }`}
              onClick={() => {
              startEdit(task)
              }}
              style={{ cursor: 'pointer' }}
            >
            <div
            style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                fontWeight: 700
            }}
            >

            <input
                type="checkbox"
                checked={task.is_completed}
                onClick={(e) => e.stopPropagation()}
                onChange={() => animateCompleteTask(task)}
            />

            <span>
                📋 {task.name}
            </span>

            </div>

            <TaskMetadata task={task} />

            {task.notes && (
              <div className="tagline" style={{ marginTop: '4px' }}>
                {task.notes}
              </div>
            )}
          </div>
        ))
    )}

    {/* RECURRING */}
    <h3 className="section-title">
      Recurring Tasks ({getRecurringForProject(selectedProject.id).length})
    </h3>

    {getRecurringForProject(selectedProject.id)
      .length === 0 ? (
      <div className="empty-state">
        🔁 No recurring support systems yet.
      </div>
    ) : (
      getRecurringForProject(selectedProject.id)
        .map(item => (
          <div
            key={item.id}
            className="season-task-card"
            onClick={() => {
                startEditRecurring(item)
            }}
            style={{ cursor: 'pointer' }}
            >
            <div style={{ fontWeight: 700 }}>
              🔁 {item.name}
            </div>

            {item.notes && (
              <div className="tagline" style={{ marginTop: '4px' }}>
                {item.notes}
              </div>
            )}
          </div>
        ))
    )}

    {/* COMPLETED TASKS */}
    <h3 className="section-title">
      Completed Tasks ({getTasksForProject(selectedProject.id).filter(t => t.is_completed).length})
    </h3>

    {getTasksForProject(selectedProject.id)
      .filter(t => t.is_completed)
      .length === 0 ? (
      <div className="empty-state">
        🏁 Nothing completed yet — progress will show here.
      </div>
    ) : (
      getTasksForProject(selectedProject.id)
        .filter(t => t.is_completed)
        .map(task => (
          <div
            key={task.id}
            className="season-task-card"
            onClick={() => {
            startEdit(task)
          }}
            style={{ cursor: 'pointer' }}
          >
          <div style={{ fontWeight: 700 }}>
            ✅ {task.name}
          </div>

          <TaskMetadata task={task} />
          
          {task.notes && (
            <div className="tagline" style={{ marginTop: '4px' }}>
              {task.notes}
            </div>
          )}
        </div>
        ))
    )}

  </div>
)}

</>
)
}